import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      <div>
        <h4>LEGAL</h4>
        <ul>
          <li>
            <a>Privacy Policy</a>
          </li>
          <li>Contact us</li>
        </ul>
      </div>

      <div>
        <h4>CUSTOMER SERVICE</h4>
        <ul>
          <li>Privacy Policy</li>
          <li>Contact us</li>
        </ul>
      </div>

      <div>
        <h4>NEWSLETTER</h4>
        <ul>
          <li>Privacy Policy</li>
          <li>Contact us</li>
        </ul>
      </div>

      <div>
        <h4>FOLLOW US</h4>
        <ul>
          <li>Privacy Policy</li>
          <li>Contact us</li>
        </ul>
      </div>
    </footer>
  );
}
